import { render, staticRenderFns } from "./SimplifiedStatisticsCardSection.vue?vue&type=template&id=022dc79f&scoped=true&"
import script from "./SimplifiedStatisticsCardSection.vue?vue&type=script&lang=js&"
export * from "./SimplifiedStatisticsCardSection.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedStatisticsCardSection.vue?vue&type=style&index=0&id=022dc79f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022dc79f",
  null
  
)

export default component.exports